import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import AuthContext from "../../context/auth/authContext";
import { IoIosCloseCircleOutline } from "react-icons/io";

const ChangePassword = ({ close }) => {
  const { loading, changeCurrentPassword } = useContext(AuthContext);
  const [details, setDetails] = useState({
    currentpassword: "",
    password: "",
    newpassword: "",
  });

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = () => {
    if (
      details.newpassword === "" ||
      details.password === "" ||
      details.currentpassword === ""
    ) {
      toast.error("Fields cannot be empty", { autoClose: 6000 });
    } else if (
      !/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
        details.password
      )
    ) {
      toast.error("Please choose a strong password", { autoClose: 6000 });
    } else if (details.password !== details.newpassword) {
      toast.error(
        "New password and confirm new password fields are not matching",
        { autoClose: 6000 }
      );
    } else {
      changeCurrentPassword({
        oldPassword: details.currentpassword,
        newPassword: details.password,
      });
    }
  };

  return (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={close}
          />
        </div>
        <div className="Register__content">
          <h2>Verify OTP</h2>
          <p>
            An verification OTP has been sent to your registered email to reset
            your password.Please enter it here. and then enter your new
            password.
          </p>
        </div>
        <div className="Register__form">
          <p>Enter Current Password</p>
          <input
            type="password"
            autoComplete="off"
            value={details.currentpassword}
            onChange={handleChange}
            name="currentpassword"
          />
          <p>Enter New Password</p>
          <input
            type="password"
            autoComplete="off"
            value={details.password}
            onChange={handleChange}
            name="password"
          />
          <p>Confirm New Password</p>
          <input
            type="password"
            autoComplete="off"
            value={details.newpassword}
            onChange={handleChange}
            name="newpassword"
          />
          <input
            type="password"
            autoComplete="on"
            value={details.newpassword}
            onChange={handleChange}
            name="newpassword"
            style={{ display: "none" }}
          />

          <div className="Register__footer">
            <button className="Register__button" onClick={handleSubmit}>
              Done
              {loading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
